const initialState = {
  lines: [],
  isFetching: true,
}

const handlers = {
  ODDS_WIDGET_LINES: (state) => ({ ...state, isFetching: true }),
  ODDS_WIDGET_LINES_SUCCESS: (state, { payload }) => ({
    ...state,
    lines: payload.lines,
    isFetching: false,
  }),
  ODDS_WIDGET_LINES_FAILURE: (state) => ({ ...state, isFetching: false }),
}

export default function lines(state = initialState, action) {
  const { type } = action

  return handlers[type] ? handlers[type](state, action) : state
}
